import React, { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import DataTable, { createTheme } from "react-data-table-component";
import { useTheme } from "../../../context/ThemeContext";
import TableLoader from "../../skeletons/TableLoader";
import dateFormat from "dateformat";
import { checkPermission, formatAMPM } from "../../../helpers/GeneralHelper";
import { utcToLocal } from "../../../helpers/DateHelper";
import { getCmsDataTableStyles } from "../../../helpers/DataTableStyles";

export default function InterviewTable({
  module,
  data,
  loading,
  totalRows,
  page,
  limit,
  fetchData,
  openUpdateModal,
  openDeleteModal,
  handleView,
  isTrash,
}) {
  

  const columns = [
    {
      name: "#",
      selector: (row, index) => <div>{ ((page -1 ) * limit) + index +1 }.</div>,
      width: '100px'
    },
    {
      name: "Client",
      selector: (row) => row.client_name,
      sortable: true,
    },
    {
      name: "Requirement",
      selector: (row) => row.requirement_name,
      sortable: true,
    },
    {
      name: "Candidate",
      selector: (row) => row.candidate_name,
      sortable: true,
    },
    // {
    //   name: "Round",
    //   selector: (row) => row.interview_round_name,
    //   sortable: true,
    // },
    {
      name: "Scheduled By",
      selector: (row) => row.recruiter_name,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => dateFormat(row.interview_date, 'dd/mm/yyyy') + ' ' + formatAMPM(new Date('2024-04-28 ' + row.interview_time)),
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status_name,
      sortable: true,
    },
    // {
    //   name: "Added On",
    //   selector: (row) => utcToLocal(row.interview_create_time)  
    // },
    // {
    //   name: "Last Edited On",
    //   selector: (row) => utcToLocal(row.interview_update_time)
    // }
  ];

  if (! isTrash && (checkPermission(module.route, 'edit') || checkPermission(module.route, 'delete'))) {
    columns.push({
      name: "Action",
      right: "true",
      cell: row => <div className="hstack gap-2 fs-15">
                    {checkPermission(module.route, 'edit') && <button type="button" className="btn btn-icon btn-sm btn-info" title="Edit" onClick={() => openUpdateModal(row)}>
                      <i className='bx bxs-edit'></i>
                    </button>}
                    
                    {checkPermission(module.route, 'delete') && <button type="button" className="btn btn-icon btn-sm btn-danger" title="Delete" onClick={() => openDeleteModal(row)}>
                      <i className='bx bxs-trash'></i>
                    </button>}
                  </div>
    });
  }

  if (isTrash) {
    columns.push({
      name: "Deleted At",
      selector: (row) => utcToLocal(row.interview_delete_time)
    });
  }

  const { theme, toggleTheme } = useTheme();

  const handlePageChange = async (page) => {
    fetchData(limit, page);
  };

  const handleLimitChange = async (newLimit, page) => {
    //if ((newLimit !== 10 && page !== 1) || localStorage.getItem(module.key)) {
      fetchData(newLimit, page);
    //}
  };

  // useEffect(() => {
  //   fetchData(limit, page);
  // }, []);

  createTheme("dark", {
    text: {
      primary: "#a2a3a4",
      secondary: "#2aa198",
    },
    background: {
      default: "#252729",
    },
    context: {
      background: "#cb4b16",
      text: "#a2a3a4",
    },
    divider: {
      default: "#073642",
    },
    action: {
      button: "rgba(0,0,0,.54)",
      hover: "rgba(0,0,0,.08)",
      disabled: "rgba(0,0,0,.12)",
    },
  });

  return (
    <DataTable
      // title={`Manage Notes (Private)`}
      onRowClicked={(row) => handleView(row)}
      className="clickable cms-data-table"
      columns={columns}
      data={data}
      pagination
      paginationServer
      paginationTotalRows={totalRows}
      onChangeRowsPerPage={handleLimitChange}
      onChangePage={handlePageChange}
      progressPending={loading}
      progressComponent={<TableLoader noOfColumn={columns.length} />}
      fixedHeader
      fixedHeaderScrollHeight="550px"
      highlightOnHover
      paginationPerPage={10}  // default page size
      paginationRowsPerPageOptions={[10, 25, 50, 100, totalRows]} // 👈 added custom options
      theme={`${theme === "light" ? "light" : "dark"}`}
      customStyles={getCmsDataTableStyles(theme)}
    />
  );
};
